"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectTransformer = void 0;
var ObjectTransformer_1 = require("./ObjectTransformer");
Object.defineProperty(exports, "ObjectTransformer", { enumerable: true, get: function () { return ObjectTransformer_1.ObjectTransformer; } });
//# sourceMappingURL=index.js.map